import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddCategory = createAsyncThunk(
  "other/AddCategory",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/category-create/`, data)
    return response.data
  }
); 

export const UpdateCategory = createAsyncThunk(
  "other/UpdateCategory",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/category-update/${data.id}/`, data)
    return response.data
  }
);

export const GetCategoryList = createAsyncThunk(
  "user/GetCategoryList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/category-list/`)
    return data
  }
);

export const DeleteCategory = createAsyncThunk(
  "other/DeleteCategory",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/category-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

